// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleDetail_TwoColumn_container","column":"ArticleDetail_TwoColumn_column","leftColumn":"ArticleDetail_TwoColumn_leftColumn"};